import React, { useRef, useState } from 'react';
import { useFormik } from 'formik';
import { useLocation } from './useLocation'; 
import { SignInSchema } from '../schema/security'; 
import { useSessionContext } from '../../../security/context/SessionContext';
import { fetchProfile, tryAuthenticate } from '../../../security/actions'; 
import { getTokenOrDefault } from '../../../helpers/Storage'; 
import { useNavigate } from 'react-router-dom';

export const useAuthenticate = () => {
	const [loading, setLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');
	const navigate = useNavigate();
	const { coordinates } = useLocation();
	const { setSession } = useSessionContext();


	const formik = useFormik({
		initialValues: {
			email_address: '',
			password: '',
		},
		validationSchema: SignInSchema,
		onSubmit: async (values) => {
			setLoading(true);
			setErrorMessage('');

			try {
				const authenticate = await tryAuthenticate(values);
				if (authenticate.is_success) {
					const _token = getTokenOrDefault();
					const profile = await fetchProfile(_token);
					if (profile.is_success && profile.status_code === 200) {
						const data: any = profile.data;
						setSession({
							isAuthenticated: true,
							user: data
						});
						navigate("/");
					}
					return;
				}

			if (authenticate.errors && authenticate.errors.length > 0) {
				setErrorMessage(authenticate.errors[0]);
			} else {
				setErrorMessage('Invalid Email or Password');
			}
		} catch (error) {
			console.error('Error during login:', error);
			setErrorMessage('Invalid Email or Password');
		} finally {
			setLoading(false);
		}
	},
	});

	return { formik, loading, errorMessage };
};
